import React from "react";
import { colors } from "../../constants/theme";
import type { Status } from "../../types";

interface BadgeProps {
  status: Status | string | undefined;
}

export const Badge: React.FC<BadgeProps> = ({ status }) => {
  const map: Record<string, React.CSSProperties> = {
    Pending: { color: "#b58900", background: "#fff8e1" },
    Processing: { color: "#0b5aa2", background: "#e3f2fd" },
    Completed: { color: "#2e7d32", background: "#e8f5e9" },
    Error: { color: "#c62828", background: "#ffebee" },
  };
  const style = map[String(status)] || { color: colors.muted, background: "#f3f4f6" };
  return <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: 999, fontSize: 12, fontWeight: 600, ...style }}>{status ?? "—"}</span>;
};

